import { z } from 'zod';

import defineBlock from '../helpers/defineBlock';
import { BlockSchema } from '../types';

export const LoopContainerBlockSchema = defineBlock(
  'LoopContainer',
  z.object({
    loopTemplate: z.string().nullish(),
    loopArgumentName: z.string().nullish(),
    loopIndexName: z.string().nullish(),
    get blocks() {
      return z.array(BlockSchema).nullish();
    },
  })
);
export type TLoopContainerBlock = z.infer<typeof LoopContainerBlockSchema>;
